import { formatOdds } from '../utils/formatOdds'
/**
 * SettlementOpenBets – expanded row ke andar dikhne wali "per bet" table
 * (Match + Fancy settlement dono isi ko use karte hain).
 *
 * Props: label, bets, loading, onVoidBet, onDeleteBet
 *
 * onDeleteBet diya ho to "Delete Bet" ka dark button bhi dikhta hai. Void bet
 * ko refund karke band karta hai; delete usi tarah refund karta hai aur uske
 * baad bet ki row + uska poora statement trail mita deta hai.
 */
export default function SettlementOpenBets({
  label,
  bets = [],
  loading = false,
  onVoidBet,
  onDeleteBet
}) {
  const betTypeBadge = (bt) => {
    const isBack = bt === 'back' || bt === 'yes' || bt === 'Yes'
    return (
      <span className={`badge ${isBack ? 'bg-primary' : 'bg-danger'} px-2`}>
        {(bt || '-').toUpperCase()}
      </span>
    )
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>Individual Bets — {label}</strong>
        <small className="text-muted">
          {bets.length} bet{bets.length !== 1 ? 's' : ''}
        </small>
      </div>

      {loading ? (
        <div className="text-center text-muted py-3">Loading bets...</div>
      ) : bets.length === 0 ? (
        <div className="text-center text-muted py-3">No open bets found</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>Bet ID</th>
                <th>User</th>
                <th>Selection</th>
                <th className="text-center">Bet Type</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
                <th className="text-end">Liability</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {bets.map((bet) => (
                <tr key={bet.id}>
                  <td>#{bet.id}</td>
                  <td>{bet.username}</td>
                  <td>{bet.selectionName || '-'}</td>
                  <td className="text-center">{betTypeBadge(bet.betType)}</td>
                  <td className="text-end">{formatOdds(bet.odds)}</td>
                  <td className="text-end">
                    {bet.stakeAmount != null ? Number(bet.stakeAmount).toFixed(2) : '-'}
                  </td>
                  <td className="text-end">
                    {bet.liability != null ? Number(bet.liability).toFixed(2) : '-'}
                  </td>
                  <td className="text-center">
                    <div className="btn-group btn-group-sm">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => onVoidBet?.(bet)}
                      >
                        Void Bet
                      </button>
                      {onDeleteBet && (
                        <button
                          type="button"
                          className="btn btn-dark"
                          onClick={() => onDeleteBet(bet)}
                        >
                          Delete Bet
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
